export enum TemplateArchiveStatus {
    NOT_ARCHIVED = 'Not Archived',
    ARCHIVED = 'Archived'
}